export enum LoginOrigin {
  None = -1,
  SetviDefault = 0,
  SetviLogin = 1,
  MiddlebyLogin = 2
}
